import React, { useState } from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "../../../components/Pagination";
import useTranslation from "../../../hooks/Translation";

const ChatInbox = () => {
  const t = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedChatId, setSelectedChatId] = useState<string | null>(null);

  const chatDetails = [
    {
      id: "C001",
      sender: "John Doe",
      receiver: "Jane Smith",
      message: "Is this still available?",
      timestamp: "2024-12-04 10:30 AM",
      type: "sent", // sent message
    },
    {
      id: "C002",
      sender: "Alice Green",
      receiver: "Bob Brown",
      message: "What’s the price?",
      timestamp: "2024-12-03 02:15 PM",
      type: "received", // received message
    },
    {
      id: "C003",
      sender: "Tom Cruise",
      receiver: "Emma Watson",
      message: "Can I get a discount?",
      timestamp: "2024-12-02 08:45 AM",
      type: "sent", // sent message
    },
    {
      id: "C004",
      sender: "Bruce Wayne",
      receiver: "Clark Kent",
      message: "When can you deliver?",
      timestamp: "2024-12-01 07:10 PM",
      type: "received", // received message
    },
    {
      id: "C005",
      sender: "Peter Parker",
      receiver: "Tony Stark",
      message: "Is this organic?",
      timestamp: "2024-11-30 01:20 PM",
      type: "sent", // sent message
    },
  ];

  // Filter chats based on search term
  const filteredChats = chatDetails.filter(
    (chat) =>
      chat.sender.toLowerCase().includes(searchTerm.toLowerCase()) ||
      chat.receiver.toLowerCase().includes(searchTerm.toLowerCase()) ||
      chat.message.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Paginated chats
  const startIndex = (page - 1) * limit;
  const paginatedChats = filteredChats.slice(startIndex, startIndex + limit);
  const totalPages = Math.ceil(filteredChats.length / limit);

  const handleDeleteChat = () => {
    // Here you should make an API call to delete the chat
    setSelectedChatId(null);
    setOpen(false);
  };

  return (
    <div>
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_heading">{t.main.chatInbox}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <div className="cards_header_right">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search chats..."
              />
            </div>
          </Box>

          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="chat inbox table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Sender</TableCell>
                  <TableCell>Receiver</TableCell>
                  <TableCell>Last Message</TableCell>
                  <TableCell>Timestamp</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedChats.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No chats found.
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedChats.map((chat, index) => (
                    <TableRow key={chat.id}>
                      <TableCell align="center">
                        {(page - 1) * limit + index + 1}
                      </TableCell>
                      <TableCell>{chat.sender}</TableCell>
                      <TableCell>{chat.receiver}</TableCell>
                      <TableCell>
                        <Box
                          className={`chat_message ${
                            chat.type === "sent"
                              ? "sent_message"
                              : "received_message"
                          }`}
                        >
                          <Typography variant="body1">
                            {chat.message}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>{chat.timestamp}</TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedChatId(chat.id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>

      {open && (
        <div>
          <p>Are you sure you want to delete this chat?</p>
          <Button onClick={handleDeleteChat}>Yes</Button>
          <Button onClick={() => setOpen(false)}>No</Button>
        </div>
      )}
    </div>
  );
};

export default ChatInbox;
